{
  "#KOMMISSIONIERUNG": {
    "APP": "Kommissionierung",
    "APP_DESC": "Vorbereitung für Entnahme/Bestellung",
    "TITLE": "Kommissionierung",
    "SUBTITLE": "Auftrag {{belegnummer}}",
    "PAGES": {
      "AUFTRAG_AUSWAHL": {
        "TITEL_OFFENE_KOMMISSIOIERUNGEN": "OFFENE KOMMISSIONIERUNGEN",
        "FILTER": "Filter",
        "AUFTRAG": "Auftrag",
        "NO_DATA": "Es sind keine Kommissionieraufträge vorhanden",
        "RETOURE": "Retoure",
        "VORKOMMISSIONIERT": "Vorkommissioniert",
        "ART": {
          "Z": "Zustellung",
          "A": "Abholung",
          "I": "Intern"
        },
        "LAGERPLATZ_AUSWAHL": "Lagerplatzauswahl",
        "KEINE_LAGERPLATZ_AUSWAHL": "Keine Lagerplatzauswahl",
        "LAGERORT_MEINE": "Meine Lagerorte"
      },
      "AUFTRAG_ARTIKEL": {
        "ARTIKEL": "Artikel",
        "MISCHAPALETTEN": "Paletten",
        "RETOURE": "Achtung: Retourschein!",
        "LOCKED": "Achtung: Dieser Auftrag wird bereits von Anwender {{anwender}} bearbeitet!",
        "INFO": "Info"
      },
      "VORKOMM_AUFTRAG_ARTIKEL": {
        "LADEMITTEL": "Lademittel",
        "SUBMIT_FINALIZE": "Lademittel erledigen"
      },
      "ARTIKEL_MENGE": {
        "LAGERPLATZ": "Lagerplatz",
        "ARTIKEL": "Artikel",
        "MENGE": "Vorgeschlagene Menge",
        "CHANGE": "Scannen",
        "SUBMIT": "Weiter",
        "RETOURE": "Achtung: Retourschein!",
        "PALETTE": "Palette auswählen"
      },
      "ABSCHLUSS": {
        "TITLE": "Begleitscheine drucken",
        "DESCRIPTION": "Bitte geben Sie die Anzahl der zu druckenden Palettenbegleitscheine an",
        "DESCRIPTION_MIXED_PALLET": "Bitte geben Sie die Anzahl der zu druckenden Palettenetiketten an",
        "AUFTRAG": "Auftrag",
        "KOMMISSIONSAUFTRAG": "Kommisionsauftrag",
        "LAGERPLATZ": "Lagerplatz",
        "MENGE": "Menge",
        "PALETTENBEGLEITSCHEINE": "Palettenbegleitscheine",
        "PALETTENETIKETT": "Palettenetiketten",
        "CHANGE": "Ändern",
        "SUBMIT": "Kommissionierung abschließen",
        "SUBMIT_RETOURE": "Retourschein abschließen",
        "RETOURE": "Achtung: Retourschein!",
        "MISCHPALETTE": "Achtung: Palette!",
        "RETOURE_ABSCHLUSS": "Sie können den Retourauftrag nun abschließen",
        "MISCHPALETTE_ABSCHLUSS": "Bitte Lagerplatz scannen um den Mischpaletten-Auftrag abzuschließen!",
        "LINKED_ORDERS": {
          "TITLE": "Verknüpfte Aufträge",
          "DESCRIPTION": "Auftrag antippen, um die aktuelle Kommissionierung abzuschließen und den Auftrag zu übernehmen",
          "SHOW_POSITIONS": "Positionen anzeigen",
          "PALLET_HINT_TITLE": "Palettenmaße fehlen",
          "PALLET_HINT": "Bitte zuerst die Maße aller Paletten erfassen, danach werden die verknüpften Aufträge angezeigt.",
          "EMPTY": "Keine verknüpften Aufträge",
          "EMPTY_READY": "Der Auftrag kann abgeschlossen werden."
        }
      },
      "FILTER": {
        "SUBMIT": "Übernehmen",
        "ART": {
          "TITLE": "Auftragsart",
          "NONE": "Alle",
          "A": "Abholung",
          "I": "Intern",
          "Z": "Zustellung"
        },
        "LAGERPLATZ_AUSWAHL": {
          "TITLE": "Lagerplatzauswahl",
          "NONE": "Alle",
          "JA": "Lagerplatzauswahl",
          "NEIN": "Keine Lagerplatzauswahl"
        },
        "RETOURE": {
          "TITLE": "Retoure",
          "NONE": "Alle",
          "JA": "Ja",
          "NEIN": "Nein"
        }
      }
    },
    "MESSAGES": {
      "SUCCESS": {
        "ABSCHLUSS": "Die Kommissionierung wurde abgeschlossen",
        "ABSCHLUSS_RETOURE": "Der Retourschein wurde abgeschlossen"
      }
    },
    "ACTIONS": {
      "FILTER": "Filter",
      "ABSCHLIESSEN": "Abschließen",
      "OFFENE_AUFTRAEGE": "Offene Aufträge",
      "EINHEITEN_UMBUCHEN": "Einheiten umbuchen"
    },
    "DIALOGS": {
      "OFFENE_AUFTRAEGE": {
        "TITLE": "Offenen Auftrag übernehmen"
      },
      "ORDER_POSITIONS": {
        "TITLE": "Positionen",
        "EMPTY": "Keine Positionen vorhanden",
        "ERROR": "Positionen konnten nicht geladen werden",
        "RETRY": "Erneut versuchen"
      },
      "EINHEITEN_UMBUCHUNG": {
        "STEPS": {
          "SOURCE": "Quelle",
          "QUANTITY": "Menge",
          "TARGET": "Ziel",
          "LOCATION": "Lagerplatz"
        },
        "LAGERPLATZ": "Lagerplatz",
        "EINHEIT": "Einheit",
        "BESTAND": "Bestand",
        "NO_STOCK": "Der Artikel hat auf keinem Lagerplatz Bestand.",
        "QUELLMENGE": "Quellmenge",
        "ZIEL_EINHEIT": "Ziel-Einheit",
        "ZIELMENGE": "Zielmenge",
        "REST": "Rest",
        "ZIEL_LAGERPLATZ": "Ziel-Lagerplatz",
        "CHANGE": "Ändern",
        "BACK": "Zurück",
        "NEXT": "Weiter",
        "BOOK": "Buchen",
        "SUCCESS": "Die Umbuchung wurde gebucht.",
        "ADD_UNIT": "Einheit hinzufügen",
        "REMOVE_UNIT": "Einheit entfernen",
        "BESTAND_HINT": "Bestand: {{menge}} {{einheit}}"
      },
      "LAGERPLATZ_AUSWAHL": {
        "TITLE": "Lagerplatz auswählen",
        "DESCRIPTION": "Für dieses Lademittel wurde noch kein Lagerplatz ausgewählt.",
        "SKIP": "Ohne Lagerplatz fortfahren"
      },
      "QUESTION": {
        "UNVOLLSTAENDIG_ABSCHLIESSEN": "Dieser Auftrag enthält noch offene Positionen. Möchten Sie diesen trotzdem abschließen?",
        "UEBERNAHME": "Möchten Sie diesen Auftrag übernehmen?",
        "FORCE_ÜBERNAHME": "Dieser Auftrag wird bereits von {{anwender}} bearbeitet. Möchten Sie diesen wirklich übernehmen?",
        "ABSCHLIESSEN_TITLE": "Abschließen",
        "ABSCHLIESSEN": "Möchten Sie die Kommissionierung wirklich abschließen?",
        "ABSCHLIESSEN_RETOURE": "Möchten Sie den Retourschein wirklich abschließen?",
        "ABSCHLIESSEN_VORKOMMISSIONIERUNG": "Möchten Sie die Vorkommissionierung wirklich abschließen?",
        "ABBRECHEN_VORKOMMISSIONIERUNG_TITLE": "Wollen Sie die Vorkommission abbrechen?",
        "ABBRECHEN_VORKOMMISSIONIERUNG": "Es wurde noch nichts gescannt, daher wird dieser Kommissionierauftrag gelöscht wenn Sie fortfahren"
      }
    },
    "FILTER_SORT": {
      "TITEL_KOMMISSIONIERUNG_ID": "Kommissionierung-ID",
      "TITEL_KUNDEN_NUMMER": "Kunden-Nummer",
      "TITEL_KUNDEN_BEZEICHNUNG": "Kunden-Bezeichnung",
      "TITEL_BELEGNUMMER_NUMMER": "Belegnummer",
      "TITEL_ANWENDER_BEZEICHNUNG": "Anwender-Bezeichnung",
      "TITEL_ABHOLDATUM": "Abholdatum",
      "TITEL_LIEFERDATUM": "Lieferdatum Von",
      "TITEL_LIEFERDATUM_BIS": "Lieferdatum Bis"
    }
  }
}
